<template>
  <DefaultBackground>
    <section class="p-5 w-full" v-show="!showExitPopup">
      <transition :name="transition" mode="out-in">
        <router-view
          v-if="!loading"
          @back="onWizardBack"
          @next="onWizardNext"
          :key="`segmentation-step-${$route.params.id}`"
        />
      </transition>
    </section>
    <transition name="scale">
      <section class="p-5 w-full" v-if="showExitPopup">
        <WizardSaveOnExit @exit="$router.push(routeToNavigate)" />
      </section>
    </transition>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import WizardSaveOnExit from "@/views/segmentation/steps/WizardSaveOnExit";
import Api from "@/api";
import Apiv1 from "@/api/api_v1.0.js";
import { mapGetters } from "vuex";

export default {
  components: {
    WizardSaveOnExit,
    DefaultBackground
  },
  data() {
    return {
      loading: false,
      showExitPopup: false,
      routeToNavigate: "",
      transition: "slide-right-fade"
    };
  },
  computed: {
    ...mapGetters(['segmentationOrder']),
  },

  watch: {
    $route(to, from) {
      if (to.meta.step <= from.meta.step) {
        this.transition = "slide-right-fade";
      } else {
        this.transition = "slide-left-fade";
      }
    }
  },

  async created() {

    this.resetSegmentationOrder();

    const questions = await Apiv1.getSegmentationQuestions();
    this.$store.commit('setSegmentationQuestions', questions.data);


    if(this.$route.query.uuid) {
      const response = await Api.getSegmentationOrderDetails(this.$route.query.uuid);
      const order = response.data;

      this.$store.commit('setSegmentationOrder', {
        process: 1,
        uuid: order.uuid,
        locationVerified: false,
        hasCollaborators: false,
        segmentations: order.segmentations.reduce((obj, seg) => ({ ...obj, [seg.question_id]: seg.answer_id }), {})
      })
    }
  },

  async mounted() {
    // if we dont have order in vuex - reset current step
    if(!this.segmentationOrder.uuid && this.$route.params.id !== '1') {
      await this.$router.push({ name: 'segmentation-wizard', query: this.$route.query })
    }
  },

  methods: {

    resetSegmentationOrder() {
      this.$store.commit("resetSegmentationOrder");
    },
    onWizardBack() {
      this.transition = "slide-left-fade"
      this.$router.go(-1);
      console.log('back');
    },
    onWizardNext() {
      this.transition = "slide-right-fade";

      const currentStep = this.$route.name;

    },

  }
};
</script>
